<template>
  <v-navigation-drawer app :color="navigation.color"
    :dark="navigation.dark"
    permanent clipped
    class="elevation-1">
    <!-- <template v-slot:prepend>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">{{ appTitle }}</v-list-item-title>
          <v-list-item-subtitle>{{ appCaption }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template> -->

    <!-- <v-divider></v-divider> -->

    <v-list dense>
      <v-list-item link v-for="item in sideNavItems" :key="item.text"
        :to="item.to"
        v-show="isRoleMatching(item.roles)">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data: () => ({ }),
  computed: {
    ...mapState([
      'appTitle',
      'appCaption',
      'navigation',
    ]),
    ...mapGetters('routes', [
      'sideNavItems',
    ]),
    ...mapGetters([
      'isRoleMatching',
    ]),
  },
  methods: {
    noop() {},
  },
};
</script>
